import { FormattedMessage } from 'react-intl';
import { Schedule } from '@/features/accounts/types';
import { type SchedulePreferencesPayload } from '@/features/accounts/api';
import { useFacilities } from '@catalog';
import { summaryView } from './summaryView';
import { fromWireInterest } from '@/shared/dateInterest';
import DateInterestPreview from '@/shared/components/DateInterestPreview';
import ModalSection from '@/shared/components/ModalSection';
import SummaryHeader from './SummaryHeader';
import LightningIcon from './LightningIcon';
import PreferencesSummary from './PreferencesSummary';
import BillingSummary from '../BillingSummary';

interface Props {
  schedule: Schedule;
  countryCode: string;
  preferences?: SchedulePreferencesPayload;
  showBillingSummary: boolean;
  costCents: number | null;
  currency: string;
}

export default function ActivationSummary({
  schedule,
  countryCode,
  preferences,
  showBillingSummary,
  costCents,
  currency,
}: Props) {
  const { data: catalog } = useFacilities(countryCode);
  const { interest, facilities } = summaryView(schedule, catalog ?? [], preferences);

  return (
    <div className="space-y-4">
      <ModalSection>
        <SummaryHeader
          titleId="schedule.activate.serviceTitle"
          descriptionId="schedule.activate.serviceDescription"
          icon={<LightningIcon />}
        >
          <div className="mt-4">
            <p className="text-sm font-semibold text-slate-900">
              <FormattedMessage id="schedule.activate.configurationTitle" />
            </p>
            <PreferencesSummary interest={interest} facilities={facilities} />

            <div className="mt-4">
              <DateInterestPreview rules={fromWireInterest(interest)} />
            </div>
          </div>
          {showBillingSummary && (
            <BillingSummary costCents={costCents} currency={currency} />
          )}
        </SummaryHeader>
      </ModalSection>
      <ModalSection>
        <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3">
          <p className="text-sm font-semibold text-amber-800">
            <FormattedMessage id="schedule.activate.warningTitle" />
          </p>
          <ul className="mt-1 list-disc pl-4 text-sm text-amber-700">
            <li><FormattedMessage id="schedule.activate.warningMonitoring" /></li>
            <li><FormattedMessage id="schedule.activate.warningRefund" /></li>
          </ul>
        </div>
      </ModalSection>
    </div>
  );
}
